import { Link } from 'react-router-dom'
import { formatDate, formatPrice } from '@wellbeingxltd/fe-lib/helpers'
import { ActionsField } from './ActionsField'

const VoucherId = ({ row }) =>
    row.row.original.used ? (
        row.value
    ) : (
        <Link aria-disabled={row.row.original.used} to={{ pathname: `/voucher/${row.value}`, state: row.row.original }}>
            {row.value}
        </Link>
    )

// The same as on W
// Color could be improved if it will be reused
const COLORS_BY_VALUE = {
    ARCHIVED: 'red',
}

export const vouchersColumns = [
    {
        Header: 'Voucher ID',
        accessor: 'uuid',
        Cell: row => <VoucherId {...{ row }} />,
    },
    {
        Header: 'Voucher code',
        accessor: 'code',
    },
    {
        Header: 'Created at',
        accessor: 'createdAt',
        Cell: ({ value }) => formatDate(value),
        disableFilters: true,
    },
    {
        Header: 'Price desc',
        accessor: 'description',
        disableFilters: true,
    },
    {
        Header: 'Price',
        accessor: 'price',
        Cell: ({ value }) => formatPrice(value),
        disableFilters: true,
    },
    {
        Header: 'Used',
        accessor: 'used',
        Cell: ({ value }) => (value ? 'Yes' : 'No'),
    },
    {
        Header: 'Used at',
        accessor: 'updatedAt',
        Cell: ({ value }) => formatDate(value),
        disableFilters: true,
    },
    {
        Header: 'Actions',
        accessor: '',
        Cell: ({ row: { original } }) => <ActionsField {...{ values: original }} />,
        disableFilters: true,
    },
]
